export const bigSvg = (text: string | number) => {
    return `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cstyle%3E .heavy %7B font: bold 30px sans-serif; fill: %23274456; text-align: center%7D %3C/style%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' class='heavy'%3E${text}%3C/text%3E%3C/svg%3E")`;
}
